module.exports = __webpack_public_path__ + "mstile-70x70.png";


//////////////////
// WEBPACK FOOTER
// ./src/icon/mstile-70x70.png
// module id = 20
// module chunks = 0